import { defineStore } from 'pinia'
import { DEBUG_MESSAGE_TYPES } from '@/constants';
export const useDebugStore = defineStore( 'debug', {
  state: () => ( {
    debugMessages: [],
    debugMessagesCount: 0
  } ),
  actions: {
    addDebugData( data, messageType = DEBUG_MESSAGE_TYPES.INFORMATION, preserveBreaks = false ) {
        const date = new Date().toLocaleString( 'en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: true
        } )
       this.debugMessages.push( { date, data, messageType, preserveBreaks } );
       this.debugMessagesCount++
      },

    clearDebugMessages() {
        // console.log( 'Clearing debug messages' )
      this.debugMessages = []
      this.debugMessagesCount = 0
    }
  }
} )